import React from 'react';

function OrderList({ items, onUpdateQuantity, onRemoveItem }) {
  if (!items || items.length === 0) {
    return <p>Scan items to add them to the order.</p>;
  }

  return (
    <ul className="order-list">
      {items.map((item) => (
        <li key={item.ean}> {/* Use EAN as the key, assuming it's unique in the order */}
          <div className="item-details">
            <strong>{item.name || 'N/A'}</strong> (EAN: {item.ean})
            <br />
            Price: ${item.price != null ? Number(item.price).toFixed(2) : 'N/A'}
            {/* Add other details if available: e.g., item.description */}
          </div>
          <div className="item-controls">
            <button onClick={() => onUpdateQuantity(item.ean, item.quantity - 1)} disabled={item.quantity <= 1}>-</button>
            <input
              type="number"
              min="1"
              value={item.quantity}
              onChange={(e) => {
                  const newQuantity = parseInt(e.target.value, 10);
                  if (!isNaN(newQuantity) && newQuantity >= 1) {
                      onUpdateQuantity(item.ean, newQuantity);
                  }
              }}
              aria-label={`Quantity for ${item.name}`}
              style={{ width: '50px', textAlign: 'center', margin: '0 5px' }}
            />
            <button onClick={() => onUpdateQuantity(item.ean, item.quantity + 1)}>+</button>
            <button className="remove-button" onClick={() => onRemoveItem(item.ean)} aria-label={`Remove ${item.name}`}>Remove</button>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default OrderList;